import { styled } from 'baseui';
import { IDummyProps, TSize } from './types';
import { StyleObject } from 'styletron-react';
import { marginSize } from '../../Utilities/utils/Theming';

export const tabsSizes: { [key: string]: { fontSize: string; lineHeight: string } } = {
	large: {
		fontSize: 'var(--epods--tabs-large-font-size)',
		lineHeight: 'var(--epods--tabs-large-line-height)',
	},
	default: {
		fontSize: 'var(--epods--tabs-default-font-size)',
		lineHeight: 'var(--epods--tabs-default-line-height)',
	},
	compact: {
		fontSize: 'var(--epods--tabs-compact-font-size)',
		lineHeight: 'var(--epods--tabs-compact-line-height)',
	},
	mini: {
		fontSize: 'var(--epods--tabs-mini-font-size)',
		lineHeight: 'var(--epods--tabs-mini-line-height)',
	},
};

export const tabWrapperStyles = (props: IDummyProps) => {
	return {
		position: 'relative',
		marginLeft: props.arrows ? '1px' : '',
	} as StyleObject;
};

export const isPresetTabsSize = (size: TSize) => size && ['large', 'default', 'compact', 'mini'].includes(size);

export const tabRootStyles = (reverse: boolean, orientation: string, size: TSize) => {
	return {
		flexDirection: reverse ? (orientation === 'horizontal' ? 'column-reverse' : 'row-reverse') : 'inherit',
		display: !reverse && orientation !== 'vertical' ? 'block' : 'flex',
		fontFamily: 'var(--epods--font-base)',
	};
};

export const tabHighlightStyles = (props: IDummyProps) => {
	let bRadius = 'var(--epods--border-radius) 0 0 var(--epods--border-radius)';
	if (props?.orientation === 'vertical' && props.reverse) {
		bRadius = '0 var(--epods--border-radius) var(--epods--border-radius) 0';
	}
	if (props?.orientation !== 'vertical' && !props.reverse) {
		bRadius = 'var(--epods--border-radius) var(--epods--border-radius) 0 0';
	}
	if (props?.orientation !== 'vertical' && props.reverse) {
		bRadius = '0 0 var(--epods--border-radius) var(--epods--border-radius)';
	}

	return {
		backgroundColor: 'transparent',
		transitionDuration: '0 !important',
		position: 'absolute',
		left: props.reverse && props.orientation === 'vertical' ? '0px' : 'inherit',
		top: props.reverse && props.orientation !== 'vertical' ? '-3px' : 'inherit',
		':after': {
			content: '""',
			display: 'block',
			maxHeight: '25px',
			height: props?.orientation === 'vertical' ? '100%' : '2px',
			borderRadius: bRadius,
			minWidth: props?.orientation === 'vertical' ? '2px' : '20px',
			maxWidth: 'calc(100% - 40px)',
			width: props?.orientation === 'vertical' ? '2px' : '100%',
			position: 'absolute',
			backgroundColor: props.noUnderline ? 'transparent' : 'var(--epods--color-bg-primary)',
			...marginSize('0', 'auto', '0', 'auto'),
			left: props?.orientation === 'vertical' ? (props.reverse ? '1px' : 'calc(100% - 1px)') : '50%',
			transform: 'translate(-50%, 50%)',
			bottom: props?.orientation === 'vertical' ? '50%' : '1px',
		},
	};
};

export const tabBorderStyles = (props: IDummyProps) => {
	if (props.noUnderline) {
		return {
			opacity: 0,
		};
	}
	return {
		height:
			props?.orientation === 'vertical' && !props?.fitTabs
				? 'inherit'
				: props?.orientation !== 'vertical' && props?.fitTabs
					? '0px'
					: '1px',
		width: props?.orientation === 'vertical' ? '1px' : 'inherit',
	};
};

export const tabListStyles = ({ arrows, headerColor, fitTabs }: IDummyProps) => {
	const base = {
		marginBottom: '0px',
		marginLeft: arrows ? '40px' : '0px',
		marginRight: arrows ? '40px' : '0px',
		overflow: 'hidden',
		justifyContent: 'flex-start',
		paddingBottom: '0px',
		paddingRight: '0px',
		display: fitTabs ? 'inline-flex' : 'flex',
		borderBottom: fitTabs ? '1px solid rgb(226, 226, 226)' : 'inherit'
	};
	if (headerColor) {
		return { ...base, backgroundColor: 'var(--epods--color-bg-heading)' };
	} else {
		return base;
	}
};

export const IconContainerF = (props: any, pos: string) => {
	return styled('div', () => {
		const posX = pos === 'left' ? { left: '0' } : { right: '0' };
		const posY = props.reverse ? { bottom: '0' } : { top: '0' };
		return {
			...{
				position: 'absolute',
				width: '40px',
				height:
					'calc(var(--epods--line-height-p) + var(--epods--space-inset-s) + var(--epods--space-inset-s) - 2px)',
				paddingTop: '0',
				backgroundColor: 'transparent',
				cursor: 'pointer',
				zIndex: 9,
			},
			...posX,
			...posY,
		} as StyleObject;
	});
};

export const iconContainerButton = {
	backgroundColor: 'transparent',
	display: 'block',
	cursor: 'pointer',
	borderWidth: '0',
	height: 'calc(var(--epods--line-height-p) + var(--epods--space-inset-s) + var(--epods--space-inset-s) - 2px)',
	width: '100%',
	paddingLeft: '4px',
	fontSize: '30px',
};
